import { inject } from '@angular/core';
import { CanMatchFn, Router } from '@angular/router';
import { forkJoin, from, of, switchMap } from 'rxjs';
import { AppConfigService } from 'src/app/core/app-config/app-config.service';
import { AuthenticationService } from '@dop/authentication';
import { UserService } from '../services/user.service';

export const authenticationGuard: CanMatchFn = () => {
  const authenticationService = inject(AuthenticationService);
  const configService = inject(AppConfigService);
  const userService = inject(UserService);
  const router = inject(Router);

  const navigation = router.getCurrentNavigation();
  let url = '/';

  if (navigation) {
    url = navigation.extractedUrl.toString();
  }

  return authenticationService.isAuthenticated().pipe(
    switchMap((isAuthenticated: boolean) => {
      if (!isAuthenticated) {
        return authenticationService.login(url).then(() => false);
      }

      return forkJoin([userService.getUserDetails(), configService.getSystemInitialData()]).pipe(
        switchMap(() => {
          return from(userService.getUserDetails()).pipe(
            switchMap(() => {
              return of(true);
            })
          );
        })
      );
    })
  );
};
